import { highlightTitleWords } from '@helpers/utils';
import * as React from 'react';
import S from './IntroBlock.styles';
import { wrapInTagsIfNeccessary } from '@helpers/richText';
const IntroBlock = (props) => {
    if (!props.title && !props.content) {
        return null;
    }
    return (React.createElement(S.Container, { "data-align": props.alignment ?? 'center', "data-size": props.titleSize ?? 'lg' },
        props.title && (React.createElement(S.Title, { dangerouslySetInnerHTML: { __html: highlightTitleWords(props.title) }, variants: props.animation })),
        props.content && (React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: wrapInTagsIfNeccessary(props.content) }, variants: props.animation }))));
};
export default IntroBlock;
